"use client";

import { useStore } from "@nanostores/react";
import { atom } from "nanostores";

import type { TLibraryTheme } from "./types/library-theme";

export const themeStore = atom<TLibraryTheme>({
  acceptOrAdmit: "accept",
  analyticsPartnerName: "",
  buttonPrimaryClass: "",
  buttonSecondaryClass: "",
  buttonTertiaryClass: "",
  directToCheckout: false,
  heading1Class: "",
  heading2Class: "",
  heading3Class: "",
  lmsURL: "",
  noGuardian: false,
  partnerID: "",
  partnerPrivacyPolicy: "",
  partnerName: "",
  partnerOnlineName: "",
  primaryColor: "",
  supportEmail: "",
  youtubeURL: "",
});

/*
  React hook to force renders when theme changes
*/
export const useTheme = () => useStore(themeStore);
